import { Component, computed, forwardRef, input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioGroupButtonOption } from './radio-group-button.interface';

@Component({
  selector: 'app-radio-group-button',
  standalone: true,
  imports: [],
  templateUrl: './radio-group-button.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupButtonComponent),
      multi: true,
    },
  ],
})
export class RadioGroupButtonComponent implements ControlValueAccessor {
  label = input<string>('');
  options = input.required<RadioGroupButtonOption[]>();
  direction = input<'vertical' | 'horizontal'>('horizontal');
  distributeWidthMode = input<'auto' | 'between'>('auto');

  value: string | null = null;
  isDisabled = false;

  containerClasses = computed(() => {
    const base = 'flex';
    const directionClass =
      this.direction() === 'vertical'
        ? 'flex-col space-y-2 mt-2'
        : 'flex-row items-center gap-4 ml-8';
    return `${base} ${directionClass}`;
  });

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: (value: string | null) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onValueChange(value: string): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
